module.exports = {
    STRIPE_FRONTEND_TOKEN: 'pk_live_51IB1xaIZBXiCvaadMF6mKpekD2qYu73oLcH6V0MSQ88irdlqPLYMORjXLD2xN08QryoDxrUr5l0BYZPE2cFxT2Bk00qwowfMzV',
    GTAG_ID: 'G-R6QXSESG3X'
}
